<template>
  <div>
    <section class="content-section">
      <h1>
        General Information
      </h1>

      <div class="content-subsection">
        <h2>
          Quote Type
        </h2>

        <div>
          {{ productBrand }} proposes to furnish all materials and engineering to 
          <span
            v-for="(v, i) in supplyInstall.value"
            :key="i + v">
            <span v-html="v"></span>
            <span v-if="i < supplyInstall.value.length - 2">, </span>
            <span v-if="i == supplyInstall.value.length - 2">
                and
            </span>
          </span>
          <template v-if="products">
            <span>{{' '}}</span>
            <span
              v-for="(v, i) in products.value"
              :key="i + v">
              <span v-html="v"></span>
              <span v-if="i < products.value.length - 2">, </span>
              <span v-if="i == products.value.length - 2">
                  and
              </span>
            </span>
          </template>
          <span>
            <span v-if="productBrand === 'Cladify'"> Cladding</span> 
            in accordance with the architectural drawings and listed qualifications.
          </span>
        </div>

        <v-rich-text-renderer
          v-if="quoteDetails.value && quoteDetails.value != ''"
          :value="quoteDetails.value" 
          :replacements="replacements"
          class="mt-3" 
        />
      </div>

      <div class="content-subsection">
        <h2>
          {{ documents.label }}
        </h2>

        <span>The following budget is based on:</span>

        <div class="content content-richtext">
          <ul>
            <li
              v-for="(document, i) in documents.value"
              :key="'doc-' + i">
              <span 
                v-for="(col, i) in documents.bind.rowTemplate"
                :key="i"
              >
                {{ col.component == 'VDatepicker' ? 
                  document[col.label] ? `[${formatDate(parseDate(document[col.label]))}]` : null : 
                  document[col.label]}}
              </span>
            </li>
          </ul>
        </div>

        <v-rich-text-renderer 
          :value="documentDetails.value" 
          :replacements="replacements"
        />
      </div>

      <template 
        v-for="section in proposalInfo.filter(
          section => !['quote_details', 'document_details', 'project_scope', 'project_exclusions', 'proposal_validity'].includes(section.id) 
            && section.d_component === 'VRichTextRenderer'
        )"
      >

        <div
          :key="section.id"
          class="content-subsection">
          <h2>
            {{ section.label }}
          </h2>
          <v-rich-text-renderer
            :value="section.value" 
            :replacements="replacements"
          />
        </div>

      </template>

      <signature-line 
        v-if="hasSignatureLine"
        class="mt-5"
        section-name="General Information"
        :has-name="false"
        :has-signature="false"
        :has-initial="true"/>

    </section>

    <section class="content-section">
      <h1>
        Inclusions & Exclusions
      </h1>

      <template 
        v-for="section in proposalInfo.filter(
          section => ['project_scope', 'project_exclusions', 'proposal_validity'].includes(section.id) 
        )"
      >

        <div
          :key="section.id"
          class="content-subsection">
          <h2>
            {{ section.label }}
          </h2>
          <v-rich-text-renderer
            :value="section.value" 
            :replacements="replacements"
          />
        </div>

      </template>

      <signature-line 
        v-if="hasSignatureLine"
        class="mt-5"
        section-name="Inclusions and Exclusions"
        :has-name="false"
        :has-signature="false"
        :has-initial="true"/>
    </section>
  </div>
</template>

<script>
import VRichTextRenderer from '@/components/base/VRichTextRenderer'
import SignatureLine from '@/components/proposalmaker/SignatureLine'
import { format, parseJSON } from 'date-fns'

export default {
  props: {
    proposal: {
      type: Object,
      required: true
    },
    productBrand: {
      type: String,
      default: 'Cladify'
    },
    replacements: {
      type: Array
    },
    hasSignatureLine: {
      type: Boolean,
      default: true
    }
  },
  components: { SignatureLine, VRichTextRenderer },
  data() {
    return {
      formatDate: (date) => {
        return date ? format(date, "MM/dd/yyyy") : null;
      },
      parseDate: (date) => { return date ? parseJSON(date) : date }
    }
  },
  computed: {
    proposalInfo() {
      return this.proposal.proposal_info;
    },
    supplyInstall() {
      return this.proposalInfo.filter(d => d.id == 'supply_install')[0];
    },
    products() {
      return this.proposalInfo.filter(d => d.id == 'products')[0];
    },
    quoteDetails() {
      return this.proposalInfo.filter(d => d.id == 'quote_details')[0];
    },
    documents() {
      return this.proposalInfo.filter(d => d.id == 'documents')[0];
    },
    documentDetails() {
      return this.proposalInfo.filter(d => d.id == 'document_details')[0];
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/pdf.css';
</style>